import { Tabs } from "antd";
import { TabsWrapper } from "../../Commons/Wrappers";
import { useState } from "react";
import ClaimTabDetails from "./ClaimTabDetails/ClaimTabDetails";
import { useTranslation } from "react-i18next";

interface IClaimTabsProps {
  defaultTab?: string;
}

const ClaimTabs = ({ defaultTab }: IClaimTabsProps) => {
  const { t } = useTranslation();

  const [keyActive, setKeyActive] = useState("details");

  const handleOnChangeTab = (key: string) => {
    setKeyActive(key);
  };

  return (
    <TabsWrapper>
      <Tabs
        items={[
          {
            key: "details",
            label: t("TABS.claim-details"),
            children: <ClaimTabDetails />,
          },
        ]}
        tabPosition="left"
        onChange={handleOnChangeTab}
        defaultActiveKey={defaultTab || keyActive}
      />
    </TabsWrapper>
  );
};

export default ClaimTabs;
